const variant = (
	`{
		id
		title
		priceV2 {
			amount
		}
		compareAtPriceV2 {
			amount
		}
		weight
		availableForSale
		sku
		product {
			id
			title
		}
		selectedOptions {
			name
			value
		}
	}`
);


const mailingAddress = (
	`{
		id
		address1
		address2
		city
		company
		country
		firstName
		formatted
		lastName
		latitude
		longitude
		phone
		province
		zip
		name
		countryCode: countryCodeV2
		provinceCode
	}`
);

const checkout = (
	`{
		id
		customAttributes {
      key
      value
    }
		ready
		requiresShipping
		note
		currencyCode
		webUrl
		orderStatusUrl
		taxExempt
		taxesIncluded
		totalTaxV2 {
			amount
		}
		lineItemsSubtotalPrice {
			amount
		}
		subtotalPriceV2 {
			amount
		}
		totalPriceV2 {
			amount
		}
		paymentDueV2 {
			amount
		}
		completedAt
		createdAt
		updatedAt
		email
		shippingAddress ${mailingAddress}
		shippingLine {
			handle
			priceV2 {
				amount
			}
			title
		}
		customAttributes {
			key
			value
		}
		order {
			id
			processedAt
			orderNumber
			currencyCode
			subtotalPriceV2 {
				amount
			}
			totalShippingPriceV2 {
				amount
			}
			totalTaxV2 {
				amount
			}
			totalPriceV2 {
				amount
			}
			totalRefundedV2 {
				amount
			}
			customerUrl
			shippingAddress ${mailingAddress}
			lineItems (first: 250) {
				edges {
					node {
						title
						variant ${variant}
						quantity
						customAttributes {
							key
							value
						}
					}
				}
			}
		}
		lineItems (first: 250) {
			edges {
				node {
					id
					title
					variant ${variant}
					quantity
					customAttributes {
						key
						value
					}
				}
			}
		}
	}`
);

export default checkout;
